import {combineReducers} from "redux";
import {chainReducers} from "@shoutem/redux-composers";
import infrastructureArea from "areas/infrastructure/reducers/infrastructureArea";
import libraryArea from "areas/library/reducers/libraryArea";
import projectsArea from "areas/projects/reducers/projectsArea";
import raiseUnhandledError from "components/BaseComponent/reducers";
import clearUnhandledError from "components/StandardLayout/reducers";
import tenantsArea from "../areas/tenants/tenantsArea";
import expanders from "components/form/Sections/reducers/expanders";
import dialogs from "components/Dialog/reducers/dialog";
import {notificationReducer} from "../components/Navbar/notifications.redux";

interface Action {
    type: string;
}

const reducers = combineReducers({
    libraryArea,
    infrastructureArea,
    projectsArea,
    tenantsArea,
    expanders,
    dialogs,
    notifications: notificationReducer,
    unhandledError: chainReducers([raiseUnhandledError, clearUnhandledError]),
});

export {reducers, Action};


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/reducers/index.ts